module.exports = __webpack_public_path__ + "img/Group 102.021e9be1.png";